import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateRichTextRequest extends BaseUpdateRequest{
	richText: string;			
}